<template>
  <div>
    人员管理
  </div>
</template>

<script>
export default {
  name: "personnel"
}
</script>

<style scoped>

</style>
